<template>
  <div class="customer-basket">
    <div class="d-flex fl-col fl-s-b aside-wrapper">
      <div class="order-summary-wrapper d-flex fl-col fl-s-b scroll-y">
        <div class="scroll-y order-summary d-flex fl-col fl-s-b">
          <div class="upper-part-container d-flex flex-row fl-s-b">
            <div class="title d-flex fl-col fl-j-c">
              <p
                :class="{
                  'long-title': isLongTitle,
                  'max-content-width': !isLongTitle,
                }"
              >
                {{ $t("asideordersummary.title") }}
              </p>
            </div>
            <div
              class="assign-customer-btn-container d-flex flex-row fl-s-b flex-align-center"
            >
              <div class="icon-container">
                <SvgIcon
                  :iconContent="iconContent"
                  :iconAlt="iconAlt"
                  :iconStyle="iconStyle"
                />
              </div>
              <p class="max-content-width">
                {{ getCustomerFullName }}
              </p>
            </div>
          </div>
          <div class="pss-list-container d-flex fl-col fl-s-a">
            <!-- style="position:relative;" -->
            <div v-if="groupedPSSList">
              <div
                v-for="pss in groupedPSSList"
                :key="String(pss.uuid)"
                :class="
                  pss.bookingStatus === BookingStatus.Canceled
                    ? 'cancelled-pss-container'
                    : ''
                "
              >
                <div class="customer-pss-container d-flex flex-row fl-s-b">
                  <div class="ticket-name-container">
                    <p class="ticket-name">
                      {{
                        // In case of a retail with only one option which is the default one we show category name
                        pss.pssType === PSSType[PSSType.Retail]
                          ? pss.optionName || pss.categoryName
                          : pss.categoryName
                      }}
                    </p>
                    <p class="price-name" v-if="showTicketInfo(pss)">
                      {{ pss.priceName }}
                    </p>
                    <p class="timeslot" v-if="showTicketInfo(pss)">
                      {{ formatDateTime(pss.startDateTime) }}
                    </p>
                    <p v-if="pss.seats && pss.seats.length" class="seat">
                      {{
                        pss.seats.length > 1
                          ? `${t("field.seat")}: ${pss.seats.join(", ")}`
                          : `${t("field.seat")}: ${pss.seats[0]}`
                      }}
                    </p>
                    <p
                      class="ticket-discount-info"
                      v-if="
                        true ||
                        ((hasGenericDiscountAccountings(pss) ||
                          isPSSConsideredInDiscount1(pss)) &&
                          !isFreeTicket(pss))
                      "
                    >
                      {{ getTicketDiscount1(pss) }}
                    </p>
                  </div>
                  <div class="quantity-container">
                    <p
                      class="quantity"
                      :class="
                        pss.bookingStatus === BookingStatus.Canceled
                          ? 'erased-tickets'
                          : ''
                      "
                    >
                      X{{ pss.quantity }}
                    </p>
                  </div>
                  <div class="unit-price-container">
                    <p
                      class="unit-price"
                      :class="
                        pss.bookingStatus === BookingStatus.Canceled
                          ? 'erased-tickets'
                          : ''
                      "
                    >
                      {{ (getPSSValue(pss) / 100).toFixed(2) }}
                    </p>
                  </div>
                  <div
                    class="total-price-container"
                    :class="{ 'with-pt': getPssGroupDiscount(pss) }"
                  >
                    <p
                      class="total-price"
                      :class="{
                        'erased-tickets':
                          pss.bookingStatus === BookingStatus.Canceled ||
                          getPssGroupDiscount(pss),
                      }"
                    >
                      {{ ((getPSSValue(pss) / 100) * pss.quantity).toFixed(2) }}
                    </p>
                    <p class="total-price" v-if="getPssGroupDiscount(pss)">
                      {{
                        (
                          (getPSSValue(pss) / 100) * pss.quantity -
                          getPssGroupDiscount(pss) / 100
                        ).toFixed(2)
                      }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    (pss.bookingStatus === BookingStatus.Confirmed ||
                      pss.bookingStatus === BookingStatus.Canceled) &&
                    isEditOrder
                  "
                  class="tickets-status-container"
                >
                  <p>
                    {{ getStatusTranslation(pss) }}
                  </p>
                </div>
              </div>
            </div>
            <!-- <el-row v-if="
                isInPaymentStep && hasAppliedDiscount && isDiscountOnAllOrder
              " class="total-container discount-container" justify="start">
              <el-col :span="5" class="total-container">
                {{ `${$t("button.discount")}:` }}
              </el-col>
              <el-col :span="5" class="total-container">
                {{ selectedBooking?.currency }}
              </el-col>
              <el-col :span="11" class="d-flex flex-row fl-a-c fl-j-e">
              </el-col>
              <el-col class="total-container text-right" :span="3">
                {{ (discountTotal1 / 100).toFixed(2) }}
              </el-col>
            </el-row> -->
          </div>

          <!-- ----- -->

          <!-- Subtotal -->
          <!-- <div v-if="isInPaymentStep || isCompletedBooking" class="w-full d-flex flex-1 fl-s-e fl-a-c">
            <div class="total-container text-left" style="width: 33%">
              {{ `${$t("field.subtotal")}:` }}
            </div>
            <div class="total-container text-center" style="width: 33%">
              {{ selectedBooking?.currency }}
            </div>
            <div class="total-container text-right" style="width: 33%">
              {{ (Number(total1) - Number(totalTax)).toFixed(2) }}
            </div>
          </div> -->

          <!-- Tax -->
          <!-- <div v-if="isInPaymentStep || isCompletedBooking" class="w-full d-flex flex-1 fl-s-e fl-a-c">
            <div class="total-container text-left" style="width: 33%">
              {{ `${$t("field.vat")}:` }}
            </div>
            <div class="total-container text-center" style="width: 33%">
              {{ selectedBooking?.currency }}
            </div>
            <div class="total-container text-right" style="width: 33%">
              {{ totalTax }}
            </div>
          </div> -->

          <!-- Total -->
          <!-- <div v-if="(isInPaymentStep || isCompletedBooking) && !isEditOrder" class="w-full d-flex flex-1 fl-s-e fl-a-c">
            <div class="total-container text-left" style="width: 33%">
              {{ `${$t("field.total")}:` }}
            </div>
            <div class="total-container text-center" style="width: 33%">
              {{ selectedBooking?.currency }}
            </div>
            <div class="total-container text-right" style="width: 33%">
              {{ total1 }}
            </div>
          </div> -->

          <!-- Total - multi currencies -->
          <!-- <div v-if="
              (isInPaymentStep || isCompletedBooking) &&
              !isEditOrder &&
              splitPayments?.length
            ">
            <div v-for="(currency, index) in currenciesUsedInPayment" :key="index">
              <div v-if="currency && currency.label !== groupCurrency?.label" class="w-full d-flex flex-1 fl-s-e fl-a-c">
                <div class="total-container text-left" style="width: 33%">
                  {{ `${$t("field.total")}:` }}
                </div>
                <div class="total-container text-center p-rel" style="width: 33%">
                  {{ currency.label }}

                  <span style="position: absolute; right: -1rem">R {{ currency.exchangeRate }}</span>
                </div>
                <div class="total-container text-right" style="width: 33%">
                  {{ (Number(total1) * currency.exchangeRate).toFixed(2) }}
                </div>
              </div>
            </div>
          </div> -->

          <!-- Total - Edit Order -->
          <!-- <div v-if="isEditOrder" class="w-full d-flex flex-1 fl-s-e fl-a-c">
            <div class="total-container text-left" style="width: 33%">
              {{ `${$t("field.total")}:` }}
            </div>
            <div class="total-container text-center" style="width: 33%">
              {{ selectedBooking?.currency }}
            </div>
            <div class="total-container text-right" style="width: 33%">
              {{ orderValueExcludingCancelledTickets }}
            </div>
          </div> -->

          <!-- Payment amounts (all payment accountings) -->
          <!-- <div v-if="splitPayments && splitPayments.length > 0" style="padding-top: 40px">
            <div v-for="payment in splitPayments" :key="payment.method"
              class="w-full d-flex flex-1 fl-s-e fl-a-c amounts-paid" style="min-height: 25px">
              <div class="text-left" style="width: 33%">
                <p>
                  {{ payment.translatedMethod }}
                </p>
              </div>
              <div class="text-center" style="width: 33%">
                <p>{{ payment.currency?.label }}</p>
              </div>
              <div class="d-flex flex-row fl-s-b" style="width: 33%">
                <div class="d-flex fl-col fl-j-c"></div>
                <div>
                  <p>
                    {{
                    payment.cashBill
                    ? payment.cashBill.toFixed(2)
                    : (
                    payment.amount * (payment.exchangeRate || 1)
                    ).toFixed(2)
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div> -->

          <!-- Total Paid & Total Refunded -->
          <!-- SHOW WHAT WAS PAID WITH BOOKINGS ACCEPTING SPLIT PAYMENT (BASED ON CONFIRMED ACCOUNTINGS) -->
          <!-- <div style="border-top: 2px solid white" v-if="splitPayments && splitPayments.length > 0">
            <div class="d-flex flex-1 fl-s-e fl-a-c" style="margin-bottom: -15px">
              <div class="confirmed-amount-total text-left" style="width: 33%">
                {{ $t("asideordersummary.amount-confirmed") }}
              </div>
              <div class="confirmed-amount-total text-center" style="width: 33%">
                {{ payingCurrency }}
              </div>
              <div class="confirmed-amount-total text-right" style="width: 33%">
                {{ (amountPaid / 100).toFixed(2) }}
              </div>
            </div>

            <div v-if="isEditOrder" class="d-flex flex-1 fl-s-e fl-a-c" style="margin-bottom: -15px">
              <div class="confirmed-amount-total text-left" style="width: 33%">
                {{ $t("asideordersummary.amount-refunded") }}
              </div>
              <div class="confirmed-amount-total text-center" style="width: 33%">
                {{ payingCurrency }}
              </div>
              <div class="confirmed-amount-total text-right" style="width: 33%">
                {{ refundedAmount.toFixed(2) }}
              </div>
            </div>
          </div> -->
          <!-- -------- -->
        </div>
        <div>
          <!-- hiiiii -->
          <div class="order-summary">
            <!-- Discount -->
            <div
              class="pss-list-container"
              style="padding-top: 3px; padding-bottom: 3px"
            >
              <el-row
                v-if="
                  isInPaymentStep && hasAppliedDiscount && isDiscountOnAllOrder
                "
                class="total-container discount-container"
                justify="start"
              >
                <el-col :span="5" class="total-container">
                  {{ `${$t("button.discount")}:` }}
                </el-col>
                <el-col :span="5" class="total-container">
                  {{ selectedBooking?.currency }}
                </el-col>
                <el-col :span="11" class="d-flex flex-row fl-a-c fl-j-e">
                </el-col>
                <el-col class="total-container text-right" :span="3">
                  {{ (discountTotal1 / 100).toFixed(2) }}
                </el-col>
              </el-row>
            </div>
            <!-- Subtotal -->
            <div
              v-if="isInPaymentStep || isCompletedBooking"
              class="w-full d-flex flex-1 fl-s-e fl-a-c"
            >
              <div class="total-container text-left" style="width: 33%">
                {{ `${$t("field.subtotal")}:` }}
              </div>
              <div class="total-container text-center" style="width: 33%">
                {{ selectedBooking?.currency }}
              </div>
              <div class="total-container text-right" style="width: 33%">
                {{ (Number(total1) - Number(totalTax)).toFixed(2) }}
              </div>
            </div>

            <!-- Tax -->
            <div
              v-if="isInPaymentStep || isCompletedBooking"
              class="w-full d-flex flex-1 fl-s-e fl-a-c"
            >
              <div class="total-container text-left" style="width: 33%">
                {{ `${$t("field.vat")}:` }}
              </div>
              <div class="total-container text-center" style="width: 33%">
                {{ selectedBooking?.currency }}
              </div>
              <div class="total-container text-right" style="width: 33%">
                {{ totalTax }}
              </div>
            </div>

            <!-- Total -->
            <div
              v-if="(isInPaymentStep || isCompletedBooking) && !isEditOrder"
              class="w-full d-flex flex-1 fl-s-e fl-a-c"
            >
              <div class="total-container text-left" style="width: 33%">
                {{ `${$t("field.total")}:` }}
              </div>
              <div class="total-container text-center" style="width: 33%">
                {{ selectedBooking?.currency }}
              </div>
              <div class="total-container text-right" style="width: 33%">
                {{ total1 }}
              </div>
            </div>

            <!-- Total - multi currencies -->
            <div
              v-if="
                (isInPaymentStep || isCompletedBooking) &&
                !isEditOrder &&
                splitPayments?.length
              "
            >
              <div
                v-for="(currency, index) in currenciesUsedInPayment"
                :key="index"
              >
                <div
                  v-if="currency && currency.label !== groupCurrency?.label"
                  class="w-full d-flex flex-1 fl-s-e fl-a-c"
                >
                  <div class="total-container text-left" style="width: 33%">
                    {{ `${$t("field.total")}:` }}
                  </div>
                  <div
                    class="total-container text-center p-rel"
                    style="width: 33%"
                  >
                    {{ currency.label }}

                    <span style="position: absolute; right: -1rem"
                      >R {{ currency.exchangeRate }}</span
                    >
                  </div>
                  <div class="total-container text-right" style="width: 33%">
                    {{ (Number(total1) * currency.exchangeRate).toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Total - Edit Order -->
            <div v-if="isEditOrder" class="w-full d-flex flex-1 fl-s-e fl-a-c">
              <div class="total-container text-left" style="width: 33%">
                {{ `${$t("field.total")}:` }}
              </div>
              <div class="total-container text-center" style="width: 33%">
                {{ selectedBooking?.currency }}
              </div>
              <div class="total-container text-right" style="width: 33%">
                {{ orderValueExcludingCancelledTickets }}
              </div>
            </div>

            <!-- Payment amounts (all payment accountings) -->
            <div
              v-if="splitPayments && splitPayments.length > 0"
              style="padding-top: 15px"
            >
              <div
                v-for="payment in splitPayments"
                :key="payment.method"
                class="w-full d-flex flex-1 fl-s-e fl-a-c amounts-paid"
                style="min-height: 25px"
              >
                <div class="text-left" style="width: 33%">
                  <p>
                    {{ payment.translatedMethod }}
                  </p>
                </div>
                <div class="text-center" style="width: 33%">
                  <p>{{ payment.currency?.label }}</p>
                </div>
                <div class="d-flex flex-row fl-s-b" style="width: 33%">
                  <div class="d-flex fl-col fl-j-c"></div>
                  <div>
                    <p>
                      {{
                        payment.cashBill
                          ? payment.cashBill.toFixed(2)
                          : (
                              payment.amount * (payment.exchangeRate || 1)
                            ).toFixed(2)
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Paid & Total Refunded -->
            <!-- SHOW WHAT WAS PAID WITH BOOKINGS ACCEPTING SPLIT PAYMENT (BASED ON CONFIRMED ACCOUNTINGS) -->
            <div
              style="border-top: 2px solid white"
              v-if="splitPayments && splitPayments.length > 0"
            >
              <div
                class="d-flex flex-1 fl-s-e fl-a-c"
                style="margin-bottom: -5px; max-height: 50px"
              >
                <div
                  class="confirmed-amount-total text-left"
                  style="width: 33%"
                >
                  {{ $t("asideordersummary.amount-confirmed") }}
                </div>
                <div
                  class="confirmed-amount-total text-center"
                  style="width: 33%"
                >
                  {{ payingCurrency }}
                </div>
                <div
                  class="confirmed-amount-total text-right"
                  style="width: 33%"
                >
                  {{ (amountPaid / 100).toFixed(2) }}
                </div>
              </div>

              <div
                v-if="isEditOrder"
                class="d-flex flex-1 fl-s-e fl-a-c"
                style="margin-bottom: -15px"
              >
                <div
                  class="confirmed-amount-total text-left"
                  style="width: 33%"
                >
                  {{ $t("asideordersummary.amount-refunded") }}
                </div>
                <div
                  class="confirmed-amount-total text-center"
                  style="width: 33%"
                >
                  {{ payingCurrency }}
                </div>
                <div
                  class="confirmed-amount-total text-right"
                  style="width: 33%"
                >
                  {{ refundedAmount.toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
          <div class="accountings-container d-flex flex-row fl-s-b">
            <p class="title d-flex fl-col fl-j-c">
              {{ $t("asideordersummary.balance-in") }} {{ currency }}
            </p>
            <p class="value d-flex fl-col fl-j-c">
              {{ whatIsLeftToPay }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import {
  BookingStatus,
  IQuantifiedProductSlotState,
  PSSType,
} from "@/types/db/product-slot-state";
import { formatDateTime } from "@/utils/helpers/dates";
import { IAccountingEntry } from "@/types/db/accounting-entry";
import {
  AccountingState,
  IAccounting,
  PaymentMethods,
  TransactionTypes,
} from "@/types/db/accounting";
import { sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { LogService } from "@/services/logging";
import { getPssGroupDiscount } from "@/utils/vue-helpers/new-accountings";

export default defineComponent({
  name: "CustomerBasket",
  props: {
    // objetcContaining all needed data for UI
    basketData: {
      required: true,
      type: Object as PropType<any>,
    },
  },
  setup(props) {
    console.log("hi from setup of CustomerBasket");

    /////// initiating reactive properties as null, in mounted hook we destructure the props ans assign these properties a value
    const showRemoveBtn = ref(null);
    const isInThePast = ref(null);
    const showCancelTicketsModal = ref(null);
    const iconContent = ref(null);
    const iconAlt = ref(null);
    const iconStyle = ref(null);
    const bookings = ref(null);
    const bookingList = ref(null);
    const currency = ref(null);
    const pssList = ref(null);
    const isCompletedBooking = ref(null);
    const bookingStep = ref(null);
    const BookingStep = ref(null);
    const isInPaymentStep = ref(null);
    const isInOrderStep = ref(null);
    const confirmedAmountsInfo = ref(null);
    const confirmedAmountsTotal = ref(null);
    const payingCurrency = ref(null);
    const getCustomerFullName = ref(null);
    const hasAppliedDiscount = ref(null);
    const isDiscountOnAllOrder = ref(null);
    const discountTotal1 = ref(null);
    const discountTotal = ref(null);
    const whatIsLeftToPay = ref(null);
    const total1 = ref(null);
    const total = ref(null);
    const isLongTitle = ref(null);
    const onClickCustomers = ref(null);
    const getPSSNewPriceValue = ref(null);
    const groupedPSSList = ref(null);
    const deleteUnconfirmedTickets = ref(null);
    const deleteTickets = ref(null);
    const isPSSConsideredInDiscount = ref(null);
    const removePayment = ref(null);
    const deleteConfirmedAmount = ref(null);
    const isAccountingCompleted = ref(null);
    const doesSupportSplitPayment = ref(null);
    const balance1 = ref(null);
    const isEditOrder = ref(null);
    const alreadyPaidAmount = ref(null);
    const refundedAmount = ref(null);
    const refreshDiscount = ref(null);
    const closeCalculator = ref(null);
    const confirmedPSSToDelete = ref(null);
    const DeleteIcon = ref(null);
    const openMessageBox = ref(null);
    const closeModal = ref(null);
    const orderValueExcludingCancelledTickets = ref(null);
    const splitPayments = ref(null);
    const amountPaid = ref(null);
    const translatePaymentMethods = ref(null);
    const totalTax = ref(null);
    const bookingSynchingDateTime = ref(null);
    const groupCurrency = ref(null);
    const currenciesUsedInPayment = ref(null);
    const getPackageTotalValue = ref(null);
    const bookingHasSeatingPlan = ref(null);
    const isRemoveButtonLoading = ref(null);
    //////////////////////////////////////////////
    const { t } = useI18n({});
    const selectedBooking = ref<any>(null);
    const groupCurrencies = ref<any>(null); //POSConfigModule.groupCurrencies;

    function showTicketInfo(pss: IQuantifiedProductSlotState): boolean {
      // Show ticket product info (startDateTime, priceName ...etc) only if the product is not a merch product
      const b = pss.pssType === PSSType[PSSType.Ticket];
      return b;
    }

    /**
     * Whether or not these pss belongs to a generic Discount accounting
     */
    function hasGenericDiscountAccountings(
      pssGroup: IQuantifiedProductSlotState
    ): boolean {
      // a list of the uuids of the pssGroup
      const rowPssListUuids = pssGroup.pssIds;
      const discountAccountings = selectedBooking.value
        ? selectedBooking.value.accountings.filter(
            (acc: IAccounting) =>
              acc.state === AccountingState.Completed &&
              (acc.paymentMethod === PaymentMethods.METHOD_DISCOUNT ||
                acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT)
          )
        : [];

      if (discountAccountings && discountAccountings.length) {
        const accEntries = discountAccountings
          .map((acc: IAccounting) => acc.accountingEntriesList)
          .flat();
        const filteredPssDiscounts = accEntries.filter(
          (item: IAccountingEntry) =>
            rowPssListUuids.some(
              (element) => element === item.productSlotStateUuid
            )
        );
        if (filteredPssDiscounts && filteredPssDiscounts.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }

    /**
     *
     * Whether or not a given pss is considerd in the promocodeDiscount or the discount
     * we identify it using discount accountings
     */
    function isPSSConsideredInDiscount1(pssGroup: IQuantifiedProductSlotState) {
      // const pssValuesTracking = BookingModule.bookingLifeTimePssValues;
      let discountAccEntries: IAccountingEntry[] = [];
      const discountAccountings = selectedBooking.value
        ? selectedBooking.value.accountings.filter(
            (acc: IAccounting) =>
              acc.transactionType ===
                TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
              !acc.refund &&
              (acc.state === AccountingState.Completed ||
                (acc.state === AccountingState.Pending && !acc.id))
          )
        : [];
      if (discountAccountings && discountAccountings.length) {
        discountAccEntries = discountAccountings
          ?.map((acc: IAccounting) => acc.accountingEntriesList)
          .flat();
      }

      const index = discountAccEntries.findIndex(
        (ae) => ae.productSlotStateUuid === pssGroup.uuid
      );

      if (index === -1) {
        // there is no discount for this pss
        return false;
      } else {
        return true;
      }
    }

    /**
     *
     * Whether or not a given pssGroup is a free ticket or not
     */
    function isFreeTicket(pssGroup: IQuantifiedProductSlotState) {
      const value = getPSSValue(pssGroup);
      const _discountValue = pssGroup._discountValue;
      return value === 0 && _discountValue === 0;
    }

    /**
     * Value returned is fully based on accountings
     * e.g: Discount 50% / CHF 6.00
     * The discount can be coming from a promocodeDiscount or a normal discount or both
     * Or from DISCOUNT accounting
     */
    function getTicketDiscount1(pssGroup: IQuantifiedProductSlotState) {
      // all pss that are concerned in discount/promocodeDiscount
      let discountAccEntries: IAccountingEntry[] = [];
      const discountAccountings = selectedBooking.value
        ? selectedBooking.value.accountings.filter(
            (acc: IAccounting) =>
              !acc.refund &&
              acc.transactionType ===
                TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
              (acc.state === AccountingState.Completed ||
                acc.state === AccountingState.Pending)
          )
        : [];
      if (!discountAccountings || !discountAccountings.length) {
        // there is no discount accountings
        return "";
      }

      discountAccEntries = discountAccountings
        .map((acc: IAccounting) => acc.accountingEntriesList)
        .flat();

      // a list of the uuids of the pssGroup
      const rowPssListUuids = pssGroup.pssIds;
      // list of pss from the pssGroup and that are considered in the discount/promocodeDiscount
      const filteredPssDiscounts = discountAccEntries.filter((ae) =>
        rowPssListUuids.some(
          (element) => element === ae.productSlotStateUuid && ae.value > 0
        )
      );
      if (filteredPssDiscounts && filteredPssDiscounts.length) {
        const pssGroupPricesSum = pssGroup.quantity * getPSSValue(pssGroup);
        const pssGroupDiscountsSum = sumArray(
          filteredPssDiscounts.map((it) => it.value)
        );

        const newPriceSum = pssGroupPricesSum - pssGroupDiscountsSum;
        return (
          t("discount.discount") +
          " " +
          (
            ((pssGroupPricesSum - newPriceSum) / pssGroupPricesSum) *
            100
          ).toFixed(0) +
          "%" +
          " / " +
          ((pssGroupPricesSum - newPriceSum) / 100).toFixed(2) +
          " " +
          String(selectedBooking.value.currency)
        );
      }
      return "";
    }

    function getStatusTranslation(pss: IQuantifiedProductSlotState) {
      if (
        pss.bookingStatus === BookingStatus.Confirmed &&
        pss.pssType === PSSType[PSSType.Retail]
      ) {
        return t("common.confirmed-sets");
      }
      if (
        pss.bookingStatus === BookingStatus.Canceled &&
        pss.pssType === PSSType[PSSType.Retail]
      ) {
        return t("common.cancelled-sets");
      }
      if (
        pss.bookingStatus === BookingStatus.Confirmed &&
        pss.pssType === PSSType[PSSType.Ticket]
      ) {
        return t("common.confirmed-tickets");
      }
      if (
        pss.bookingStatus === BookingStatus.Canceled &&
        pss.pssType === PSSType[PSSType.Ticket]
      ) {
        return t("common.cancelled-tickets");
      }
    }

    return {
      groupCurrencies,
      getStatusTranslation,
      showRemoveBtn,
      isInThePast,
      showCancelTicketsModal,
      iconContent,
      iconAlt,
      iconStyle,
      t,
      bookings,
      bookingList,
      selectedBooking,
      currency,
      pssList,
      isCompletedBooking,
      bookingStep,
      BookingStep,
      isInPaymentStep,
      isInOrderStep,
      confirmedAmountsInfo,
      confirmedAmountsTotal,
      payingCurrency,
      getCustomerFullName,
      hasAppliedDiscount,
      isDiscountOnAllOrder,
      discountTotal1,
      discountTotal,
      whatIsLeftToPay,
      total1,
      total,
      isLongTitle,
      isPSSConsideredInDiscount1,
      isPSSConsideredInDiscount,
      isFreeTicket,
      PSSType,
      onClickCustomers,
      getPSSNewPriceValue,
      getTicketDiscount1,
      groupedPSSList,
      deleteUnconfirmedTickets,
      AccountingState,
      deleteTickets,
      showTicketInfo,
      formatDateTime,
      removePayment,
      deleteConfirmedAmount,
      isAccountingCompleted,
      doesSupportSplitPayment,
      balance1,
      isEditOrder,
      alreadyPaidAmount,
      refundedAmount,
      refreshDiscount,
      closeCalculator,
      BookingStatus,
      confirmedPSSToDelete,
      DeleteIcon,
      openMessageBox,
      closeModal,
      orderValueExcludingCancelledTickets,
      splitPayments,
      amountPaid,
      translatePaymentMethods,
      totalTax,
      PaymentMethods,
      bookingSynchingDateTime,
      hasGenericDiscountAccountings,
      groupCurrency,
      currenciesUsedInPayment,
      getPSSValue,
      getPackageTotalValue,
      bookingHasSeatingPlan,
      isRemoveButtonLoading,
      getPssGroupDiscount,
    };
  },
  async mounted() {
    console.log("hi from mounted of customerBasket");

    this.updateData();

    watch(this.$props, () => {
      console.log("props has been changed");
      this.updateData();
    });
    console.log("done mounted");
  },
  updated() {
    console.log("hi from updated of customerBasket");
  },
  methods: {
    updateData() {
      console.log("hi from updateData");
      this.selectedBooking = this.$props.basketData.selectedBooking;
      this.groupCurrencies = this.$props.basketData.groupCurrencies;
      this.showRemoveBtn = this.$props.basketData.showRemoveBtn;
      this.isInThePast = this.$props.basketData.isInThePast;
      this.showCancelTicketsModal =
        this.$props.basketData.showCancelTicketsModal;
      this.iconContent = this.$props.basketData.iconContent;
      this.iconAlt = this.$props.basketData.iconAlt;
      this.iconStyle = this.$props.basketData.iconStyle;
      this.bookings = this.$props.basketData.bookings;
      this.bookingList = this.$props.basketData.bookingList;
      this.currency = this.$props.basketData.currency;
      this.pssList = this.$props.basketData.pssList;
      this.isCompletedBooking = this.$props.basketData.isCompletedBooking;
      this.bookingStep = this.$props.basketData.bookingStep;
      this.BookingStep = this.$props.basketData.BookingStep;
      this.BookingStep = this.$props.basketData.BookingStep;
      this.isInPaymentStep = this.$props.basketData.isInPaymentStep;
      this.isInOrderStep = this.$props.basketData.isInOrderStep;
      this.confirmedAmountsInfo = this.$props.basketData.confirmedAmountsInfo;
      this.confirmedAmountsTotal = this.$props.basketData.confirmedAmountsTotal;
      this.payingCurrency = this.$props.basketData.payingCurrency;
      this.getCustomerFullName = this.$props.basketData.getCustomerFullName;
      this.hasAppliedDiscount = this.$props.basketData.hasAppliedDiscount;
      this.isDiscountOnAllOrder = this.$props.basketData.isDiscountOnAllOrder;
      this.discountTotal1 = this.$props.basketData.discountTotal1;
      this.discountTotal = this.$props.basketData.discountTotal;
      this.whatIsLeftToPay = this.$props.basketData.whatIsLeftToPay;
      this.total1 = this.$props.basketData.total1;
      this.total = this.$props.basketData.total;
      this.isLongTitle = this.$props.basketData.isLongTitle;
      this.onClickCustomers = this.$props.basketData.onClickCustomers;
      this.getPSSNewPriceValue = this.$props.basketData.getPSSNewPriceValue;
      this.groupedPSSList = this.$props.basketData.groupedPSSList;
      this.deleteUnconfirmedTickets =
        this.$props.basketData.deleteUnconfirmedTickets;
      this.deleteTickets = this.$props.basketData.deleteTickets;
      this.isPSSConsideredInDiscount =
        this.$props.basketData.isPSSConsideredInDiscount;
      this.removePayment = this.$props.basketData.removePayment;
      this.deleteConfirmedAmount = this.$props.basketData.deleteConfirmedAmount;
      this.isAccountingCompleted = this.$props.basketData.isAccountingCompleted;
      this.doesSupportSplitPayment =
        this.$props.basketData.doesSupportSplitPayment;
      this.balance1 = this.$props.basketData.balance1;
      this.isEditOrder = this.$props.basketData.isEditOrder;
      this.alreadyPaidAmount = this.$props.basketData.alreadyPaidAmount;
      this.refundedAmount = this.$props.basketData.refundedAmount;
      this.refreshDiscount = this.$props.basketData.refreshDiscount;
      this.closeCalculator = this.$props.basketData.closeCalculator;
      this.confirmedPSSToDelete = this.$props.basketData.confirmedPSSToDelete;
      this.DeleteIcon = this.$props.basketData.DeleteIcon;
      this.openMessageBox = this.$props.basketData.openMessageBox;
      this.closeModal = this.$props.basketData.closeModal;
      this.orderValueExcludingCancelledTickets =
        this.$props.basketData.orderValueExcludingCancelledTickets;
      this.splitPayments = this.$props.basketData.splitPayments;
      this.amountPaid = this.$props.basketData.amountPaid;
      this.translatePaymentMethods =
        this.$props.basketData.translatePaymentMethods;
      this.totalTax = this.$props.basketData.totalTax;
      this.bookingSynchingDateTime =
        this.$props.basketData.bookingSynchingDateTime;
      this.groupCurrency = this.$props.basketData.groupCurrency;
      this.currenciesUsedInPayment =
        this.$props.basketData.currenciesUsedInPayment;
      this.getPackageTotalValue = this.$props.basketData.getPackageTotalValue;
      this.isRemoveButtonLoading = this.$props.basketData.isRemoveButtonLoading;
    },
  },
});
</script>

<style lang="scss">
// In order to make the below responsive we will need to:
// 0- Take sizes properties computed values from MAC screen & turn them into vh values to be responsive
// 1- Take 100vh from Hamza's MAC screen window.innerHeight (791px) and calculate variable avh = 791/100 = 7.91
// 2- For each row in Hamza's MAC screen, take computed following properties: height & min-height, and convert their values to be related to avh
// 3- example: .upper-container-part computed height = 45px --> newRelativeHeight = 45 / avh = 5.68 so we write in the class height:5.68vh
// 4- example: .customer-pss-container computed height 86px and min-height 80px, so we do newRelativeMinHeight = 80/avh = 10.11 so new min-height=10.11vh. No need for height here as it's not mentionned below
// 5- Width that are using percentage should not be updated
// 6- Width that are using static values should be changed to percentage
// 7- After getting done with height property we will need to do the same with paddings & margins (bottom & top)
// 8- After getting done from rows height measures, we proceed with font-size & line-height of each one and use the same logic so that font-size &line-height will be related to vh (implicitly they are related to their own parents' height)
// 9- Icons (for now only customer icon) are now using static values, they should be using percentage for both width and height to be relative to their own parents.

@import "@/styles/variables.scss";
.customer-basket {
  width: 35%;
  // $summary-width: 390px;

  .el-aside {
    width: unset;
  }

  .order-summary-wrapper {
    flex-grow: 3;
    width: 100%;
    // padding: 5px 15px;
    padding-top: 0.63vh; //5px;==> newPaddingTop = 5/avh = 5/7.91 = 0.63
    padding-bottom: 0.63vh; //5px;==> newPaddingBottom = 5/avh = 5/7.91 = 0.63
    border-radius: $border-radius;
    background-color: $color-dark-grey-2;
    color: white;

    .order-summary {
      padding-left: 15px;
      padding-right: 15px;
      .upper-part-container {
        height: 5.86vh; //45px;==> newHeight = 45/avh = 45/7.91 = 5.86
        min-height: 5.86vh; //45px;==> newHeight = 45/avh = 45/7.91 = 5.86

        .title {
          text-align: left;
          line-height: 3.67vh; //29px;==> lineHeight = 29/avh = 29/7.91 = 3.67
          letter-spacing: 0px;
          color: white;
          font-weight: 700;
          font-style: normal;
          font-size: 2.78vh; //22px;==> fontSize = 22/avh = 22/7.91 = 2.78
        }

        .max-content-width {
          width: max-content;
        }

        .long-title {
          font-size: 2.02vh; //16px;==> fontSize = 16/avh = 16/7.91 = 2.02
          line-height: 2.52vh; //20px;==> lineHeight = 20/avh = 20/7.91 = 2.52
        }

        .assign-customer-btn-container {
          line-height: 2.15vh; //17px;==> lineHeight = 17/avh = 17/7.91 = 2.15
          letter-spacing: 0px;
          color: white;
          font-weight: 400;
          font-style: normal;
          font-size: 1.64vh; //13px;==> fontSize = 13/avh = 13/7.91 = 1.64
          text-align: center;
          border-left: 1px solid gray;
          padding-left: 10px;

          .icon-container {
            margin-right: 10px;
          }
        }
      }

      .pss-list-container {
        padding-top: 1.26vh; //10px;==> newPaddingTop = 10/avh = 10/7.91 = 1.26
        padding-bottom: 1.26vh; //10px;==> newPaddingBottom = 10/avh = 10/7.91 = 1.26

        .customer-pss-container {
          padding-top: 0.37vh; //3px;==> newPaddingTop = 3/avh = 3/7.91 = 0.37
          padding-bottom: 0.37vh; //3px;==> newPaddingTop = 3/avh = 3/7.91 = 0.37
          // min-height: 10.11vh; //80px;==> newMinHeight = 80/avh = 80/7.91 = 10.11
          // min-height: 2.52vh; //20px;==> newHeight = 20/avh = 20/7.91 = 2.52
          align-items: center;
          border-bottom: 1px solid white;

          .ticket-name-container {
            width: 40%;
            text-align: left;

            .ticket-name {
              font-weight: 700;
              font-style: normal;
              font-size: 1.76vh; //14px;==> fontSize = 14/avh = 14/7.91 = 1.76
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
              margin-bottom: 0.63vh; //5px;==> newPaddingTop = 5/avh = 5/7.91 = 0.63
            }
            .price-name,
            .ticket-discount-info {
              font-weight: 400;
              font-style: normal;
              font-size: 1.26vh; //10px;==> fontSize = 10/avh = 10/7.91 = 1.26
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
            }
            .ticket-discount-info {
              font-weight: 600;
            }
            .timeslot {
              font-weight: 400;
              font-style: normal;
              font-size: 1.26vh; //10px;==> fontSize = 10/avh = 10/7.91 = 1.26
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
            }
            .seat {
              font-weight: 400;
              font-style: normal;
              font-size: 1.26vh; //10px;==> fontSize = 10/avh = 10/7.91 = 1.26
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          .quantity-container {
            width: 20%;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .quantity {
              font-weight: 700;
              font-style: normal;
              font-size: 1.51vh; //12px;==> fontSize = 12/avh = 12/7.91 = 1.51
              text-align: right;
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
              letter-spacing: 0px;
              margin-right: 8px;
            }
          }

          .unit-price-container {
            width: 20%;
            text-align: center;

            .unit-price {
              font-weight: 700;
              font-style: normal;
              font-size: 1.51vh; //12px;==> fontSize = 12/avh = 12/7.91 = 1.51
              text-align: right;
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
              letter-spacing: 0px;
            }
          }
          .total-price-container.with-pt {
            padding-top: 1.2rem;
          }
          .total-price-container {
            width: 20%;
            text-align: right;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            .total-price {
              font-weight: 700;
              font-style: normal;
              font-size: 1.51vh; //12px;==> fontSize = 12/avh = 12/7.91 = 1.51
              text-align: right;
              line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
              letter-spacing: 0px;
            }
          }

          .erased-tickets {
            text-decoration: line-through;
          }
        }

        .tickets-status-container {
          font-weight: 700;
          font-style: normal;
          font-size: 1.51vh; //12px;==> fontSize = 12/avh = 12/7.91 = 1.51
          line-height: 1.51vh; //12px;==> lineHeight = 12/avh = 12/7.91 = 2.52
          text-align: right;
          width: 100%;
          color: yellow;
          margin-top: -1.89vh; //-15px;==> newMarginTop = -15/avh = -15/7.91 = -1.89
          padding-bottom: 0.63vh; //5px;==> newPaddingTop = 5/avh = 5/7.91 = 0.63
        }

        .cancelled-pss-container {
          background-color: rgba(
            $color: $color-grid-button-purple /*$color-dark-grey-2 */,
            $alpha: 0.5
          );
        }
      }

      .total-container {
        line-height: 3.79vh; //30px;==> lineHeight = 30/avh = 30/7.91 = 3.79
        height: 3.79vh; //30px;==> newHeight = 30/avh = 30/7.91 = 3.79
        font-weight: 700;
        font-style: normal;
        font-size: 1.76vh; //14px;==> fontSize = 14/avh = 14/7.91 = 1.76
        // padding-left: 1%;
      }

      .tax-container {
        border-bottom: 1px solid white;
      }

      .discount-container {
        font-size: 1.51vh; //12px;==> fontSize = 12/avh = 12/7.91 = 1.51
        line-height: 3.79vh; //30px;==> lineHeight = 30/avh = 30/7.91 = 3.79
        height: 3.79vh; //30px;==> newHeight = 30/avh = 30/7.91 = 3.79
      }

      .confirmed-amount-container {
        border-bottom: 1px solid white;
        border-top: 1px solid white;

        .confirmed-amount {
          height: 5.05vh; //40px;==> newHeight = 40/avh = 40/7.91 = 5.05
          font-weight: 700;
          font-style: normal;
          font-size: 1.76vh; //14px;==> fontSize = 14/avh = 14/7.91 = 1.76
          line-height: 1.76vh; //14px;==> lineHeight = 14/avh = 14/7.91 = 1.76
          margin-bottom: 0.63vh; //5px;==> newMarginBottom = 5/avh = 5/7.91 = 0.63
        }
      }

      .confirmed-amount-total {
        font-weight: 700;
        font-style: normal;
        font-size: 1.76vh; //14px;==> fontSize = 14/avh = 14/7.91 = 1.76
        // text-align: right;
        line-height: 6.32; //50px;==> lineHeight = 50/avh = 50/7.91 = 6.32
        // height: 50px;
        letter-spacing: 0px;
      }
    }

    .accountings-container {
      height: 5.68vh; //45px;==> newHeight = 45/avh = 45/7.91 = 5.68
      border-top: 2px solid white;
      padding-left: 15px;
      padding-right: 15px;

      .title {
        text-align: left;
      }
      .value {
        text-align: right;
      }
      .title,
      .value {
        font-weight: 700;
        font-style: normal;
        font-size: 2.02vh; //16px;==> fontSize = 16/avh = 16/7.91 = 2.02
        text-align: left;
        line-height: 2.52vh; //20px;==> lineHeight = 20/avh = 20/7.91 = 2.52
        letter-spacing: 0px;
      }
    }
  }

  .discount-hundreds {
    padding-left: 2%;
  }

  .discount-dozens {
    padding-left: 4%;
  }

  .confirmed-ones {
    padding-left: 3%;
  }

  .confirmed-dozens {
    padding-left: 5%;
  }

  .confirmed-hundreds {
    padding-left: 1%;
  }

  .aside-wrapper {
    width: 100%;
    height: 100vh;
    min-height: 100%;
  }

  .amounts-paid {
    font-weight: 800;
    font-style: normal;
    font-size: 1.76vh; //14px;==> fontSize = 14/avh = 14/7.91 = 1.76
    line-height: 2.52vh; //20px;==> lineHeight = 20/avh = 20/7.91 = 2.52
    letter-spacing: 0px;
  }
}
</style>
